import {createContext} from 'react'

export const ToggleContext = createContext({
    isOpen: false,
    setIsOpen: (isOpen) => !isOpen
})
